import React from "react";
import { connect } from "react-redux";
import { validarLiga } from "./servicios.act";
import { sinValidarLiga } from "./servicios.act";
import { goTo } from "../tools";
import LigaExpiro from "./ligaExpiro.cmpt";
import ErrorGeneral from "./errorGeneral.cmpt";
import Seguridad from "./seguridad.cmpt";
import Exito from "./exito.cmpt";
import LoSentimos from "./loSentimos.cmpt";
import Contrato from "./contrato.cmpt";
import Confidencialidad from "./confidencialidad.cmpt";
import firebase from 'firebase';

const mapState = (state) => {
	return {
		paso: state.recuperar.paso,
		loader: state.global.loader,
	};
};

const mapDispatch = (dispatch) => {
	return {
		validarLiga: (uid, time, status, token) => {
			dispatch(validarLiga(uid, time, status, token));
		},
		sinValidarLiga: () => {
			dispatch(sinValidarLiga());
		},
		showLoad: () => {
			dispatch({ "type": "LOADER_SHOW" });
		},
		alerta: (sTitulo, sMensaje, fnCerrar) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": sTitulo, "mensaje": sMensaje, "accion": fnCerrar });
		},
	};
};

class Flujo extends React.Component {

	componentWillMount = () => {
		this.props.showLoad();

		if (this.props.hashOne && this.props.hashOne !== "" && this.props.hashTwo && this.props.hashTwo !== "" && this.props.hashThree && this.props.hashThree !== "") {
			const hash1 = this.props.hashOne;
			const hash2 = this.props.hashTwo;
			const hash3 = this.props.hashThree;
			const hash5 = localStorage.getItem("hashFive");

			firebase.database().ref("/olvideContrasenia").once("value").then(snapshot=>{
				var data = snapshot.val();
				if(data.show === true ){
					this.props.validarLiga(hash1, hash2, hash3, hash5);
				} else {
					this.props.sinValidarLiga();
				}
			});

		} else {
			this.props.alerta("ERROR", "La liga no puede ser procesada", () => {
				goTo("login");
			});
		}
	}

	componentDidMount = () => {
		localStorage.setItem("hash1", this.props.hashOne);
		localStorage.setItem("hashOne", this.props.hashOne);
		localStorage.setItem("hashTwo", this.props.hashTwo);
		localStorage.setItem("hashThree", this.props.hashThree);
	}

	render() {
		var paso = '';
		if (this.props.paso === "confidencialidad") {
			paso = "gnp-generales gnp-registro";
		} 
		else {
			paso = "gnp-generales loginGNP";
		}

		return (
			<div>
				<div className={paso} style={{width: "1250px", height: "440px"}} >
					<div className="content">
						{!this.props.loader && this.props.paso === "formnm" &&
							<Seguridad tipo="nm"/>
						}
						{!this.props.loader && this.props.paso === "expiro" &&
							<LigaExpiro />
						}
						{!this.props.loader && this.props.paso === "error" &&
							<ErrorGeneral />
						}
						{!this.props.loader && this.props.paso === "losentimos" &&
							<LoSentimos />
						}
						{!this.props.loader && this.props.paso === "contrato" &&
							<Contrato />
						}
						{!this.props.loader && this.props.paso === "confidencialidad" &&
							<Confidencialidad />
						}
						{!this.props.loader && this.props.paso === "exito" &&
							<Exito />
						}
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Flujo);



// WEBPACK FOOTER //
// ./src/gnp-recuperar-contrasenia/flujo.cmpt.js